import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';
import PillTabs from 'components/shared/tabs/PillTabs';
import AdminClientPlayResults from 'components/play/AdminClientPlayResults';
import PlayClientMetricsPanel from 'components/play/coach/PlayClientMetricsPanel';
import PlayClientWorkoutsList from 'components/play/coach/PlayClientWorkoutsList';
import PlayClientRoutineView from 'components/play/coach/PlayClientRoutineView';

/**
 * OTRIX Play (coach) — ficha completa de un cliente Play para admin/entrenador:
 * Resultados (calificables) · Métricas · Entrenamientos · Rutina. Antes solo existían
 * los resultados; ahora el coach ve la película completa del cliente.
 */
function PlayCoachView({ clientId }) {
  const { t } = useTranslation(['play']);
  const [tab, setTab] = useState(0);

  return (
    <Container maxWidth="xl" sx={{ pb: 4 }}>
      <PillTabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        centered
        ariaLabel={t('coach.tabsLabel', { ns: 'play', defaultValue: 'Ficha del cliente Play' })}
        sx={{ mb: 3 }}
        tabs={[
          { key: 'results', label: t('coach.tabResults', { ns: 'play', defaultValue: 'Resultados' }) },
          { key: 'metrics', label: t('coach.tabMetrics', { ns: 'play', defaultValue: 'Métricas' }) },
          { key: 'workouts', label: t('coach.tabWorkouts', { ns: 'play', defaultValue: 'Entrenamientos' }) },
          { key: 'routine', label: t('coach.tabRoutine', { ns: 'play', defaultValue: 'Rutina' }) }
        ]}
      />

      {/* Resultados conserva su propio layout (viene de AdminClientPlayResults). */}
      {tab === 0 && <AdminClientPlayResults clientId={clientId} />}
      {tab === 1 && (
        <Box>
          <PlayClientMetricsPanel clientId={clientId} />
        </Box>
      )}
      {tab === 2 && <PlayClientWorkoutsList clientId={clientId} />}
      {tab === 3 && <PlayClientRoutineView clientId={clientId} />}
    </Container>
  );
}

PlayCoachView.propTypes = {
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default PlayCoachView;
